export const REACT_QUERY_DEFAULT_MAX_FAILURES = 3;
